import FarmEvent from "@/FarmEvent"
import { list, object, primitive, serializable, serialize } from "serializr"
import Farm from "@/farm/Farm"
import util from "@/util"
import Employee from "@/employee/Employee"

export class ChatMessage {
  @serializable
  public readonly id: string
  @serializable
  public readonly msg: string
  @serializable
  public readonly time: number

  constructor(msg: string, time: number, id: string = util.uuid()) {
    this.id = id
    this.msg = msg
    this.time = time
  }
}

export default class ChatHistory {
  @serializable(list(object(ChatMessage)))
  public history: any[] = []

  private farm: Farm = new Farm()

  update(dt: number, farm: Farm) {
    this.farm = farm
  }

  /**
   * Adds a message to this chat.
   * @param msg
   * @param options
   *          * id: string, an ID for this message, if left out the message will be given a random ID
   *          * maxFrequency: number, how many seconds have to pass between two messages using this ID
   */
  addMessage(msg: string, options: any = {}) {
    let id = ('id' in options) ? options.id : util.uuid()

    // Do not post message if that id was posted recently
    if ('maxFrequency' in options && this.timeSinceLastPosted(id) < options.maxFrequency) return

    this.history.unshift(new ChatMessage(msg, this.farm.state.time, id))
    if (this.history.length >= 10) {
      this.history = this.history.slice(0, this.history.length - 1)
    }
  }

  private timeSinceLastPosted(id: string) {
    for (let msg of this.history) {
      if (msg.id == id) {
        return this.farm.state.time - msg.time
      }
    }
    return Number.MAX_VALUE
  }

  toJSON() {
    return serialize(this)
  }
}
